<template>
  <div class="full-screen">
    <sui-header >Payment Information</sui-header>
    <sui-message warning>{{message}}</sui-message>
    <sui-form>
      <sui-form-field>
        <label>Name on the Card *</label>
        <input placeholder="Full Name" v-model="fullName" >
      </sui-form-field>
      <sui-form-field>
        <label>Credit / Debit Card</label>
        <card class='stripe-card'
              :class='{ complete }'
              :stripe='stripeKey'
              :options='stripeOptions'
              @change='complete = $event.complete'/>
      </sui-form-field>
    </sui-form>
    <sui-message error v-if="errorMessage">{{errorMessage}}</sui-message>
    <div class="actions">
      <sui-button type="button" class='pay-with-stripe' @click='close'>Close</sui-button>
      &nbsp;
      <sui-button type="button" class='pay-with-stripe' @click='getToken' :disabled='!isValid' primary>Save</sui-button>
    </div>
    <div class="spacemaker mobile only">

    </div>
  </div>
</template>

<script>
    import { Card, createToken } from 'vue-stripe-elements-plus'
    import StripeUtils from "../../utils/StripeUtils";
    export default {
      name: "PaymentDetails",
      components: {Card},
      props: ["open", "message", "billingCustomer"],
      data () {
        return {
          thisOpen: true,
          fullName: "",
          address1: "",
          address2: "",
          city: "",
          postCode: "",
          complete: false,
          stripeOptions: {},
          tokenID: null,
          errorMessage: null
        }
      },
      computed: {
        stripeKey: function() {
          return StripeUtils.getStripeKey()
        },
        isValid: function () {
          return this.complete
        },
      },
      methods: {
        async close() {
          this.$emit('complete')
        },
        async getToken() {
          try {
            let tokenResponse = await createToken({
              name: this.fullName,
              address_line1: this.address1,
              address_line2: this.address2,
              address_city: this.city,
              address_zip: this.postCode,
              address_country: 'GB'
            })
            let token = tokenResponse.token
            this.tokenID = token.id
            this.$emit('complete', token.id)

          } catch (err) {
            this.errorMessage = err
          }
        },
      },
      mounted: function() {
        this.fullName = this.billingCustomer.FullName
        this.address1 = this.billingCustomer.AddressLine1
        this.address2 = this.billingCustomer.AddressLine2
        this.city = this.billingCustomer.City
        this.postCode = this.billingCustomer.PostCode
      },
      watch: {
        open: function(newValue) {
          alert('open')
          this.thisOpen = newValue
        }
      }
    }
</script>

<style scoped>
  .stripe-card {
    /*background: #FAFAFA;*/
    border: 1px solid #E0E0E0;
    padding: 5pt 5pt;
    border-radius: 5pt;
  }
  .stripe-card.complete {
    border-color: rgba(0, 128, 0, 0.2);
    background: rgba(0, 128, 0, 0.01);
  }
  .spacemaker {
    height: 250pt;
  }
</style>
